import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LicenceActions, {
   getLicenceData,
   isFetchingLicence,
} from 'pgdb-data-layer/lib/Redux/LicenceRedux';
import { isSaveApplicationSuccess, isSavingApplication } from 'pgdb-data-layer/lib/Redux/ApplicationsRedux';
import * as REGISTRATION from 'pgdb-data-layer/lib/Constants/Registration';
import Loading from '../../Components/Loading';
import StepIndicator from '../../Components/StepIndicator';
import { getToken } from '../../Session/SessionRedux';
import Navigator from '../../Navigation/Navigator';
import EndorsementSelectionStep from './Endorsements/EndorsementSelectionStep';
import './Endorsements/ApplyEndorsement.scss';
import { isFetchingFeeRequest } from 'pgdb-data-layer/lib/Redux/PaymentRedux';
import EndorsementActions, {getEndorsement, isFetchingEndorsement} from 'pgdb-data-layer/lib/Redux/EndorsementRedux';
import { ENDORSEMENT_TYPE_PLUMBER, ENDORSEMENT_TYPE_DRAINLAYER } from 'pgdb-data-layer/lib/Helpers/Endorsement';
import ActiveEndorsements from '../../Components/ActiveEndorsements';
import EndorsementTimeLimitNotice from './Endorsements/EndorsementTimeLimitNotice';

export const STEPS_ENDORSEMENT_FORM = [
   { label: 'Type' },
   { label: 'Details' },
   { label: 'Training' },
   { label: 'Payment' },
];

const EndorsementTypePage = ({ token, licences, isLoading, getLicences, applicationsCreated, isSaveApplicationSuccess, activeEndorsement, getUserEndorsement, isRenewal }) => {
   const [selectedEndorsements, setSelectedEndorsements] = useState({
      plumber: false,
      drainlayer: false,
   });
   const [isDisabled, setIsDisabled] = useState(true);

   useEffect(() => {
      if (token && (!licences.currentLicences || licences.currentLicences.length === 0)) {
         getLicences(token);
      }
      if(token && (!activeEndorsement || activeEndorsement.length === 0)) {
         getUserEndorsement(token);
      }
   }, [token, getLicences, getUserEndorsement]);

   useEffect(() => {
      setIsDisabled(!selectedEndorsements.plumber && !selectedEndorsements.drainlayer);
   }, [selectedEndorsements]);

   const getActiveCertifyingLicences = () => {
      if (!licences || !licences.currentLicences) {
         return { hasPlumber: false, hasDrainlayer: false };
      }

      const endorsements = activeEndorsement.endorsements || [];
      const activeCertifying = licences.currentLicences.filter(
         licence =>
            licence.status === 'Active' &&
            (licence.typeCode === REGISTRATION.CERTIFYING_PLUMBER_CODE || licence.typeCode === REGISTRATION.CERTIFYING_DRAINLAYER_CODE)
      );

      const canRenewPlumber = endorsements.some(e => e.endorsementTypeCode === ENDORSEMENT_TYPE_PLUMBER && e.canApplyForRenewal);
      const canRenewDrainlayer = endorsements.some(e => e.endorsementTypeCode === ENDORSEMENT_TYPE_DRAINLAYER && e.canApplyForRenewal);
      const canApplyPlumber = activeCertifying.some(l => l.typeCode === REGISTRATION.CERTIFYING_PLUMBER_CODE) && !endorsements.some(e => e.endorsementTypeCode === ENDORSEMENT_TYPE_PLUMBER);
      const canApplyDrainlayer = activeCertifying.some(l => l.typeCode === REGISTRATION.CERTIFYING_DRAINLAYER_CODE) && !endorsements.some(e => e.endorsementTypeCode === ENDORSEMENT_TYPE_DRAINLAYER);

      if (isRenewal) {
         return {
            hasPlumber: canRenewPlumber || canApplyPlumber,
            hasDrainlayer: canRenewDrainlayer || canApplyDrainlayer,
            isRenewingPlumber: canRenewPlumber,
            isRenewingDrainlayer: canRenewDrainlayer,
         };
      }

      return {
         hasPlumber: canApplyPlumber,
         hasDrainlayer: canApplyDrainlayer,
      };
   };

   const eligibility = getActiveCertifyingLicences();

   const handleNext = (applicationId) => {
      if (isRenewal) {
         Navigator.toRenewEndorsementDetails(applicationId);
      } else {
         Navigator.toEndorsementDetails(applicationId);
      }
   };


      React.useEffect(() => {
         if (isSaveApplicationSuccess && applicationsCreated && applicationsCreated.length > 0) {
            handleNext(applicationsCreated[0].applicationId);
         }
      }, [isSaveApplicationSuccess]);

   return (
      <main>
         <Loading isLoading={isLoading} overlayOnChildren={true}>
            <div className="section no-pad-bot" id="index-banner">
               <div className="container registration-container">
                  <div className="row no-margin flex">
                     <div className="col s10 m10 l10 offset-l1">
                        <div className="row profile-row">
                           <h4 className="columnheader">{isRenewal ? 'Endorsement Renewal' : 'Endorsement Application'}</h4>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <StepIndicator steps={STEPS_ENDORSEMENT_FORM} currentStep={1} />
            <EndorsementTimeLimitNotice />
            <EndorsementSelectionStep
               selectedEndorsements={selectedEndorsements}
               setSelectedEndorsements={setSelectedEndorsements}
               endorsements={activeEndorsement.endorsements}
               eligibility={eligibility}
               isDisabled={isDisabled}
               onNext={handleNext}
               isRenewal={isRenewal}
            />
         </Loading>
      </main>
   );
};

EndorsementTypePage.propTypes = {
   token: PropTypes.string.isRequired,
   licences: PropTypes.object.isRequired,
   isLoading: PropTypes.bool.isRequired,
   getLicences: PropTypes.func.isRequired,
   getUserEndorsement: PropTypes.func.isRequired,
   activeEndorsement: PropTypes.object.isRequired,
   isSaveApplicationSuccess: PropTypes.bool.isRequired,
   applicationsCreated: PropTypes.array.isRequired,
   isRenewal: PropTypes.bool,
};

const mapStateToProps = state => ({
   isLoading: isFetchingLicence(state)|| isSavingApplication('saveApplication', state) || isFetchingEndorsement('getUserEndorsement',state) ,
   licences: getLicenceData(state),
   token: getToken(state),
   activeEndorsement: getEndorsement(state).endorsement,
   isSaveApplicationSuccess: isSaveApplicationSuccess('saveApplication',state),
   applicationsCreated: state.application.payload.applications || [],
});

const mapDispatchToProps =  {
   getLicences: LicenceActions.licenceRequest,
   getUserEndorsement: EndorsementActions.getUserEndorsementRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(EndorsementTypePage);
